<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">新增</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="banners"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           title="新增小程序轮播图">
      <Form ref="banner"
            :model="form"
            :label-width="80">
        <Form-item label="标题"
                   prop="title">
          <Input type="text"
                 v-model="form.title" />
        </Form-item>
        <Form-item label="跳转链接"
                   prop="link">
          <Input type="text"
                 v-model="form.link" />
          <p style="color: gray"
             v-if="form.platform === 'mini'">支持 [appid:][page url]，appid:开头时代表跳转到第三方小程序</p>
        </Form-item>
        <Form-item label="平台">
          <Select label-in-value
                  @on-change="change_platform"
                  v-model="form.platform">
            <Option v-for="item in banner_platforms"
                    :value="item.code"
                    :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        <Form-item label="类型">
          <Select label-in-value
                  @on-change="change_category"
                  v-model="form.category">
            <Option v-for="item in banner_categories"
                    :value="item.code"
                    :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        <Form-item label="图片"
                   prop="image">
          <uploader @uploadedUrl="uploadedUrl"
                    :category="form.category"
                    :url="form.image"></uploader>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import Uploader from '@/components/uploader-aliyun/single'
import { deleteButtonInTable, editorButtonInTable, tableAvatar, tableVideo, bannerPlatform, bannerCategory } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
    Uploader
  },
  watch: {
    banner (val) {
      if (val && val.id) {
        this.form = val
      }
    }
  },
  data () {
    return {
      banner_platforms: [
        { text: '', code: '' },
        { text: '小程序', code: 'mini' },
        { text: '前台', code: 'front' },
        { text: '小程序开屏', code: 'splash' }
      ],
      banner_categories: [
        { text: '', code: '' },
        { text: '图片', code: 'picture' },
        { text: '视频', code: 'video' }
      ],
      form: {
        title: '',
        link: '',
        platform: '',
        category: '',
        image: ''
      },
      modalShow: false,
      formType: '',
      columns: [
        {
          title: '标题',
          key: 'title',
          width: 180
        },
        {
          title: '平台',
          key: 'platform',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return bannerPlatform(h, params.row.platform)
            // return h('div', params.row.platform === 'mini' ? '小程序' : '前台')
          }
        },
        {
          title: '类别',
          key: 'category',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return bannerCategory(h, params.row.category)
            // return h('div', params.row.category === 'picture' ? '图片' : '视频')
          }
        },
        {
          title: '跳转地址',
          key: 'link',
          width: 300
        },
        {
          title: '缩略图',
          key: 'image',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return params.row.category === 'video' ? tableVideo(h, params.row.image) : tableAvatar(h, params.row.image)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('banner', ['banner', 'banners', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('banner', [
      'clearRecord',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('banner', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    change_platform (e) {
      this.form.platform = e ? e.value : ''
    },
    change_category (e) {
      this.form.category = e ? e.value : ''
    },
    uploadedUrl (url) {
      const { form } = this
      form.image ? form.image = url : this.$set(form, 'image', url)
    },
    add () {
      this.clearRecord()
      this.form = {}
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.form)
      } else if (this.formType === 'new') {
        await this.create(this.form)
      }
      this.modalShow = false
    }
  }
}
</script>
